// src/components/admin/branding/CustomContent.tsx
import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

interface CustomContentProps {
  type: 'css' | 'header' | 'footer';
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const CustomContent: React.FC<CustomContentProps> = ({
  type,
  value,
  onChange,
}) => {
  const getLabel = () => {
    switch (type) {
      case 'css':
        return 'Custom CSS';
      case 'header':
        return 'Custom Header';
      case 'footer':
        return 'Custom Footer';
    }
  };

  const getName = () => {
    switch (type) {
      case 'css':
        return 'customcss';
      case 'header':
        return 'customheader';
      case 'footer':
        return 'customfooter';
    }
  };

  const getHelperText = () => {
    switch (type) {
      case 'css':
        return 'Custom CSS to be applied to the application';
      case 'header':
        return 'Custom HTML for the application header';
      case 'footer':
        return 'Custom HTML for the application footer';
    }
  };

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h6" gutterBottom>
        {getLabel()}
      </Typography>
      <TextField
        fullWidth
        name={getName()}
        label={getLabel()}
        multiline
        rows={6}
        value={value || ''}
        onChange={onChange}
        helperText={getHelperText()}
      />
    </Box>
  );
};

export default CustomContent;
